import apiClient from './api'

export async function uploadImageToCloudinary(file, folder) {
  const signatureResponse = await apiClient.post('/api/cms/media/sign', { folder })
  const { cloudName, apiKey, timestamp, signature } = signatureResponse.data

  const formData = new FormData()
  formData.append('file', file)
  formData.append('api_key', apiKey)
  formData.append('timestamp', timestamp)
  formData.append('signature', signature)
  formData.append('folder', folder)

  const uploadResponse = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/image/upload`, {
    method: 'POST',
    body: formData
  })

  if (!uploadResponse.ok) {
    throw new Error('Cloudinary upload failed')
  }

  const data = await uploadResponse.json()

  return {
    imageUrl: data.secure_url,
    imagePublicId: data.public_id
  }
}
